export default __webpack_public_path__ + "static/chuden-logo-c56babacfa9ec672b027bf0497a1c34d.jpg";